import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/config";
interface FilterOptions {
  yearOptions: { id: string; label: string }[];
  monthOptions: { id: string; label: string }[];
  mrNameOptions: { id: string; label: string }[];
}

const useFilterOptions = (userId: string) => {
  const [filterOptions, setFilterOptions] = useState<FilterOptions>({
    yearOptions: [{ id: "1", label: "2023" }],
    monthOptions: [
      { id: "1", label: "January" },
      { id: "2", label: "February" },
      { id: "3", label: "March" },
      { id: "4", label: "April" },
      { id: "5", label: "May" },
      { id: "6", label: "June" },
      { id: "7", label: "July" },
      { id: "8", label: "August" },
      { id: "9", label: "September" },
      { id: "10", label: "October" },
      { id: "11", label: "November" },
      { id: "12", label: "December" },
    ],
    mrNameOptions: [{ id: "1", label: "Demo" }],
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
     if (!userId) return; 
    const fetchData = async () => {
      try {
        setIsLoading(true);

        const filterResponse = await fetch(
          `${API_BASE_URL}Filters/Filters?userId=${userId}&userType=SAP_USER`
        );
        if (!filterResponse.ok) {
          throw new Error("Failed to fetch filter data");
        }

        const filterData = await filterResponse.json();

        // if (filterData.years && Array.isArray(filterData.years)) {
        //   const transformedYears = filterData.years.map(
        //     (year: string, index: number) => ({
        //       id: (index + 1).toString(),
        //       label: year.replace("FY ", ""),
        //     })
        //   );
        //   setFilterOptions((prev) => ({
        //     ...prev,
        //     yearOptions: transformedYears,
        //   }));
        // }
          const getLastThreeYears = () => {
  const currentYear = new Date().getFullYear();

  return Array.from({ length: 3 }, (_, index) => ({
    id: (index + 1).toString(),
    label: (currentYear - index).toString(),
  }));
};
setFilterOptions((prev) => ({
  ...prev,
  yearOptions: getLastThreeYears(),
}));

        if (filterData.months && Array.isArray(filterData.months)) {
          const transformedMonths = filterData.months.map(
            (month: string, index: number) => ({
              id: (index + 1).toString(),
              label: month,
            })
          );
          setFilterOptions((prev) => ({
            ...prev,
            monthOptions: transformedMonths,
          }));
        }

        if (filterData.filter_Data && Array.isArray(filterData.filter_Data)) {
          const mrNameOptions: { id: string; label: string }[] = [];
          filterData.filter_Data.forEach((division: any) => {
            division.zones.forEach((zone: any) => {
              zone.regions.forEach((region: any) => {
                region.hQs.forEach((hq: any) => {
                  hq.employees.forEach((employee: any) => {
                    if (employee.user_role === "MR") {
                      mrNameOptions.push({
                        id: employee.userid.toString(),
                        label: employee.username,
                      });
                    }
                  });
                });
              });
            });
          });
          setFilterOptions((prev) => ({
            ...prev,
            mrNameOptions,
          }));
        }

        setIsLoading(false);
      } catch (err: any) {
        setError(err.message);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  return { filterOptions, isLoading, error };
};

export default useFilterOptions;
